import React, { Component } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

import LogoImageUrl from '../../../images/stock_color_transparent.png'

const LogoContainer = styled.div`
  margin-top: 14px;
  float: left;

  >a {
    color: #FFFFFF;
  }
`

const LogoImage = styled.img`
  width: 138px;
  height: 30px;
  object-fit: cover;
  margin-left: -8px;
`

class Logo extends Component {

    render() {
        return(
            <LogoContainer>
                <Link to='/dashboard'>
                    <LogoImage src={LogoImageUrl} alt="Amazon Stock Portal" className="amazon-portal-logo"/>
                </Link>
            </LogoContainer>
        )
    }
}

export default Logo
